import React from 'react';
import { Text } from '../';

const InfoItem = ({ label, value }) => {
  return (
    <div className="d-flex flex-column w-100 mb-2">
      <Text className="my-0" color="grayText" size="md">
        {label}
      </Text>
      <Text className="mt-2 line-height-normal" size="md">
        {value || '-'}
      </Text>
    </div>
  );
};

export default InfoItem;
